import { PhysicsImpostor } from '@babylonjs/core/Physics/physicsImpostor';
export const initMeshCollidable = (ctx, mesh) => {
    mesh.physicsImpostor = new PhysicsImpostor(mesh, PhysicsImpostor.MeshImpostor, {
        mass: 0,
        friction: 1,
        restitution: 0,
    }, ctx.getScene());
};
